import script from "./IconSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconSort.vue?vue&type=script&lang=ts&setup=true"

import "./IconSort.vue?vue&type=style&index=0&id=8918d168&lang=css"

const __exports__ = script;

export default __exports__